export default __webpack_public_path__ + "static/icon-tile-color-light-25aa9c306d50303cb35b8f5b85249345882af7847520d6923ee916799e906ee3.png";